import { isExternal, isEmpty } from '../util/helpers'

export default {
  init() {
    // JavaScript to be fired on all pages
    const body = document.querySelector('body')
    const navToggle = document.querySelector('.js-toggle-nav')
    const anchors = [].slice.call(document.querySelectorAll('a'))
    const pTags = [].slice.call(document.querySelectorAll('p'))
    const heroBackground = document.querySelector('.js-hero')
    const sectionBackgrounds = [].slice.call(document.querySelectorAll('.js-section-background'))
    const formInputs = [].slice.call(document.querySelectorAll('.gfield .datepicker'))

    // Handle toggling mobile menu
    if (window.matchMedia('(max-width: 1023px)').matches) {
      if (!navToggle) return

      navToggle.addEventListener('click', (e) => {
        e.preventDefault()

        body.classList.toggle('nav-is-open')
      })
    }

    // Handle external urls
    anchors.forEach(anchor => {
      if (isExternal(anchor)) {
        // Define attributes to set
        const attributes = {
          target: '__blank',
          rel: 'noopener',
        }

        // Set attributes
        Object.keys(attributes).forEach(attribute => {
          anchor.setAttribute(attribute, attributes[attribute])
        })
      }
    })

    // Handle empty p tags
    pTags.forEach(isEmpty)

    // Handle hero background
    if (heroBackground) {
      const mobileHero = heroBackground.dataset.mobile
      const desktopHero = heroBackground.dataset.desktop

      if (!mobileHero && !desktopHero) return

      heroBackground.classList.add('has-background')

      if (window.matchMedia('(min-width: 1024px)').matches) {
        heroBackground.style.backgroundImage = `url(${desktopHero})`
      } else {
        heroBackground.style.backgroundImage = `url(${mobileHero})`
      }
    }

    // Handle section background images
    if (sectionBackgrounds) {
      sectionBackgrounds.forEach(sectionBackground => {
        const mobileBG = sectionBackground.dataset.mobile
        const desktopBG = sectionBackground.dataset.desktop

        if (!mobileBG && !desktopBG) return

        if (window.matchMedia('(min-width: 1024px)').matches) {
          sectionBackground.style.backgroundImage = `url(${desktopBG})`
        } else {
          sectionBackground.style.backgroundImage = `url(${mobileBG})`
        }
      })
    }

    // Gravity Forms
    if (formInputs) {
      formInputs.forEach(formInput => {
        formInput.setAttribute('autocomplete', 'off')
      })
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js